import { render, staticRenderFns } from "./yearFrameCreateEdit.vue?vue&type=template&id=3db7bb1c&scoped=true"
import script from "./yearFrameCreateEdit.vue?vue&type=script&lang=js"
export * from "./yearFrameCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./yearFrameCreateEdit.vue?vue&type=style&index=0&id=3db7bb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db7bb1c",
  null
  
)

export default component.exports